module.exports = __webpack_public_path__ + "img/variable.6ccba5ab.svg";